import { UIPick, UserPicksResponse } from "models/Models";

export const createUIPicks = (data: UserPicksResponse) => {
    return data.series.map((m) => {
      const existing = data.picks.find((c) => c.seriesId === m.id);
      const pick: UIPick = {
        homeTeamId: m.homeTeamId,
        homeTeamName: m.homeTeamName,
        homeTeamSeed: m.homeTeamSeed,
        homeTeamWins: m.homeTeamWins,
        awayTeamId: m.awayTeamId,
        awayTeamName: m.awayTeamName,
        awayTeamWins: m.awayTeamWins,
        seriesId: m.id,
        teamId: existing?.teamId || 0,
        games: existing?.games || 0,
        round: m.round,
        totalGames: m.homeTeamWins + m.awayTeamWins,
        winningTeamId: m.homeTeamWins === 4 ? m.homeTeamId : m.awayTeamWins === 4 ? m.awayTeamId : undefined,
        division: m.divisionId,
        pickedTeamName:
          existing && existing.teamId === m.homeTeamId ? m.homeTeamName : existing && existing.teamId === m.awayTeamId ? m.awayTeamName : undefined,
        homeTeamShortName: m.homeTeamShortName,
        awayTeamShortName: m.awayTeamShortName,
        isOpen: m.isOpen,
      };
      return pick;
    });
  };
